import classNames from "classnames";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { FaCreditCard } from "react-icons/fa";
import { FiFile } from "react-icons/fi";
import { Api } from "../../../../services/api";
import { formatCurrency } from "../../../../utils/formatCurrency";

export const Simulation = ({rowInfo,close,toast}) =>{
    //const {visao} = useInfo();
    const [simulationData,setSimulationData] = useState([]);
    //const [providerID] = useState(rowInfo.usuario_id);
    const [type,setType] = useState('B');
    const [loading,setLoading] = useState(true);

    const handleSimulation = async(e) =>{
        let parcelas = 5
        try {
            const {data} = await Api.get(`/cobranca/pegatotalparcelas/${rowInfo.usuario_documento}`)
            parcelas = data.cobranca_boleto_parcela ? data.cobranca_boleto_parcela : 5
        } catch (error) {
            console.log(error.response)
        }
        const value = rowInfo.valor_pagamento;
        setLoading(true);
        if(value){
            try {
                const { data } = await Api.get(
                    `/parcelamentos/list/${value}/${e}/${parcelas}/visa`);
                    setSimulationData(data);
                setLoading(false);
            } catch (error) {
                switch (error.response.status) {
                    case 404:
                        toast('error','Erro de conexão com o servidor');
                        break;
                    case 500:
                        toast('error','Erro ao realizar simulação');
                        break;
                    default:
                        toast('error','Erro de conexão com o servidor');
                        break;
                }
                console.log(error.response);
                setLoading(false);
            }
        }

        else toast('error','Verifique se a cobrança ainda está com o status Em Aberto')

    }

    function installmentsBody (e){
        const data = e.numero_parcela.concat('x de ',formatCurrency(e.valor_parcela))
        return (data)
    }
    const Empty = (
        <div>
        <h6>Erro ao carregar simulação...</h6>
        </div>
    )
    const simulationHeader = (
            <div className="grid w-full">
                <div className="grid w-full md:w-8/12" >
                    <h5><b>Forma de Pagamento: </b>{type === "B" ? ("Boleto"):("Cartão")}</h5>
                </div>
                <div className="flex gap-3 mt-3">
                    <div className="grid w-full lg:w-2/12" >
                        <Button
                        severity="success"
                        label="Boleto"
                        icon={<FiFile/>}
                        onClick={()=>{setType('B');handleSimulation('B')}} />
                    </div>
                    <div className="grid w-full lg:w-2/12" >
                        <Button
                        severity="info"
                        label="Cartão"
                        icon={<FaCreditCard/>}
                        onClick={()=>{setType('C');handleSimulation('C')}} />
                    </div>
                </div>
            </div>
        )


    useEffect(()=>{
        handleSimulation('B')
    },[])

    return(
        <Dialog
        visible
        header="Simulação"
        pt={{
            root: 'w-screen md:w-[70vw] max-h-[80vh] ',
            header: classNames('flex items-center justify-between shrink-0',
            'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
            'dark:bg-gray-900  dark:text-white/80'),
            content: ({ state }) => ({
            className: classNames('overflow-auto w-full max-h-[80vh]', 
                'bg-white text-gray-700 px-6 pb-8 pt-0', 
                'rounded-bl-lg rounded-br-lg grid', 
                'dark:bg-gray-900 dark:text-white/80 ', {
                'grow': state.maximized
            })
            }),
        }}
        onHide={()=>close()}
        ><div>
            <DataTable
            value={simulationData}
            header={simulationHeader}
            loading={loading}
            emptyMessage={Empty}
            >
                <Column header="Parcelas" body={rowData => installmentsBody(rowData)} />
                <Column header="Total" body={rowData => formatCurrency(rowData.valor_parcela*rowData.numero_parcela)} />
                <Column header="Valor Original" body={() => formatCurrency(rowInfo.cobranca_valor)} />
                <Column header="Juros, Multa e Serviço" body={rowData=> formatCurrency((rowData.valor_parcela*rowData.numero_parcela)-rowInfo.cobranca_valor)} />
            </DataTable>

        </div>
        </Dialog>
    )
}
